import type { RouteObject } from "react-router-dom";
import { ExpensesPage } from "./ExpensesPage";
import { NewExpensePage } from "./NewExpensePage";
import { ImportPage } from "./import/ImportPage";
import { RequireView } from "../payroll/kit";
import { areaAllows } from "../../app/nav";

export const routes: RouteObject[] = [
  { path: "expenses", element: <RequireView allow={(h) => areaAllows("expenses", h)}><ExpensesPage /></RequireView> },
  { path: "expenses/import", element: <RequireView allow={(h) => h("expenses.import")}><ImportPage /></RequireView> },
  { path: "expenses/new", element: <RequireView allow={(h) => h("expenses.add")}><NewExpensePage /></RequireView> },
];
